import { FormattedMessage as FM } from "react-intl";

import { ShoppingBagIcon } from "components/Icons";
import { getContrastText } from "../helpers/colors";

function PreviewCart({ colors }) {
  const primary = colors.primary_color;
  const accent = colors.accent_color;
  return (
    <div
      className="flex items-center justify-between gap-2 rounded-xl px-3 py-2"
      style={{ backgroundColor: primary, color: getContrastText(primary) }}
    >
      <span className="flex items-center gap-2 text-[11px] font-medium">
        <ShoppingBagIcon
          width={14}
          className="fill-current"
          style={{ color: accent }}
        />
        <FM id="melhous.dash.preview.cart" />
      </span>
      <span
        className="flex size-4 items-center justify-center rounded-full text-[9px] font-bold"
        style={{ backgroundColor: accent, color: getContrastText(accent) }}
      >
        2
      </span>
    </div>
  );
}

export default PreviewCart;
